// Event tracking service for local analytics
const EVENTS_KEY = 'zenermind_events';

export const EventTracker = {
  track(eventName, data = {}) {
    const event = {
      eventName,
      timestamp: new Date().toISOString(),
      ...data
    };
    
    const events = this.getEvents();
    events.push(event);
    
    try {
      localStorage.setItem(EVENTS_KEY, JSON.stringify(events));
    } catch {
      // Storage failed silently
    }
  },
  
  getEvents() {
    try {
      const events = localStorage.getItem(EVENTS_KEY);
      return events ? JSON.parse(events) : [];
    } catch {
      return [];
    }
  },
  
  exportEvents() {
    return this.getEvents();
  },
  
  clearEvents() {
    localStorage.removeItem(EVENTS_KEY);
  }
};

// Convenience methods for common events
export const trackEvent = {
  sessionStarted: (sessionId) => EventTracker.track('session_started', { sessionId }),
  focusScreenCompleted: () => EventTracker.track('focus_screen_completed'),
  onboardingCompleted: () => EventTracker.track('onboarding_completed'),
  guessMade: (symbol, round) => EventTracker.track('guess_made', { symbol, round }),
  sessionCompleted: (hits, accuracy, level) => EventTracker.track('session_completed', { hits, accuracy, level }),
  pdfRequested: (sessionId) => EventTracker.track('pdf_requested', { sessionId }),
  upgradeClicked: (source) => EventTracker.track('upgrade_clicked', { source }),
  historyViewed: () => EventTracker.track('history_viewed')
};
